import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3","key":"svg-0"}],["path",{"d":"M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3","key":"svg-1"}],["path",{"d":"M11 11l1 -1v4","key":"svg-2"}]]

const IconRepeatOnce = createReactComponent('outline', 'repeat-once', 'RepeatOnce', __iconNode);

export default IconRepeatOnce;